export default [
  /*** 产品配置 开始 ***/
  {
    path: '/product/config',
    component: () => import('../pages/operation/config/index.vue'),
    meta: { title: '产品配置' }
  },
  /*** 产品配置 结束 ***/

  /*** 优惠券 开始 ***/
  {
    path: '/coupon/list',
    component: () => import('../pages/operation/coupon/index.vue'),
    meta: { title: '优惠券管理' }
  },
  {
    path: '/coupon/create',
    component: () => import('../pages/operation/coupon/create.vue'),
    meta: { title: '优惠券创建' }
  },
  {
    path: '/coupon/edit/:couponId',
    component: () => import('../pages/operation/coupon/edit.vue'),
    meta: { title: '优惠券编辑' }
  },
  /*** 优惠券 结束 ***/

  /*** 拼团 开始 ***/
  {
    path: '/activity/list',
    component: () => import('../pages/operation/activity/index.vue'),
    meta: { title: '拼团管理' }
  },
  {
    path: '/activity/create',
    component: () => import('../pages/operation/activity/create.vue'),
    meta: { title: '拼团创建' }
  },
  {
    path: '/activity/edit/:activityId',
    component: () => import('../pages/operation/activity/edit.vue'),
    meta: { title: '拼团编辑' }
  },
  /*** 拼团 结束 ***/


  /*** 联报 开始 ***/
  {
    path: '/joint/list',
    component: () => import('../pages/operation/joint/index.vue'),
    meta: { title: '联报管理' }
  },
  {
    path: '/joint/create',
    component: () => import('../pages/operation/joint/create.vue'),
    meta: { title: '联报创建' }
  },
  {
    path: '/joint/edit',
    component: () => import('../pages/operation/joint/edit.vue'),
    meta: { title: '联报修改' }
  },
  /*** 联报 结束 ***/


  /*** 订单管理 开始 ***/
  {
    path: '/order/list',
    component: () => import('../pages/order/index.vue'),
    meta: { title: '订单管理' }
  },
  {
    path: '/order/create',
    component: () => import('../pages/order/create.vue'),
    meta: { title: '订单创建' }
  },
  {
    path: '/order/commodityChange',
    component: () => import('../pages/order/commodityChange.vue'),
    meta: { title: '商品兑换' }
  },

  /*** 订单管理 结束 ***/

  /*** 学长预约 开始 ***/
  {
    path: '/order/booking',
    component: () => import('../pages/senior/booking/index.vue'),
    meta: { title: '学长预约' }
  },
  /*** 学长预约 结束 ***/

  /*** 乐高原创 开始 ***/
  {
    path: '/page/list',
    component: () => import('../pages/operation/page/index.vue'),
    meta: { title: '乐高原创' }
  },
  {
    path: '/page/detail/:pageId',
    component: () => import('../pages/lego/index.vue'),
    meta: { title: '乐高原创' }
  },
  /*** 乐高原创 结束 ***/

  /*** QQ群管理 开始 ***/
  {
    path: '/group/list',
    component: () => import('../pages/operation/group/index.vue'),
    meta: { title: 'QQ群管理' }
  },
  /*** QQ群管理 结束 ***/

  /*** 积分任务 开始 ***/
  {
    path: '/points/task/list',
    component: () => import('../pages/operation/points/index.vue'),
    meta: { title: '积分任务' }
  },
  /*** 积分任务 结束 ***/



  {
    path: '/college/menu/list',
    component: () => import('../pages/operation/collegeMenu/index.vue'),
    meta: { title: '院校菜单' }
  },
  {
    path: '/college/menu/edit/:menuId',
    component: () => import('../pages/operation/collegeMenu/edit.vue'),
    meta: { title: '院校菜单编辑' }
  },
  {
    path: '/college/menu/create',
    component: () => import('../pages/operation/collegeMenu/create.vue'),
    meta: { title: '院校菜单创建' }
  },
  /*** 院校菜单 结束 ***/




  {
    path: '/template/list',
    component: () => import('../pages/operation/template/index.vue'),
    meta: { title: '模板管理' }
  },
  {
    path: '/template/create',
    component: () => import('../pages/operation/template/create.vue'),
    meta: { title: '模板创建' }
  },
  {
    path: '/template/edit',
    component: () => import('../pages/operation/template/edit.vue'),
    meta: { title: '模板修改' }
  },

  {
    path: '/groupmessage/list',
    component: () => import('../pages/operation/groupmessage/index.vue'),
    meta: { title: '群发任务' }
  },
  {
    path: '/promotionLink/list',
    component: () => import('../pages/operation/promotionLink/index.vue'),
    meta: { title: '推广链接' }
  },
  {
    path: '/groupmessage/create',
    component: () => import('../pages/operation/groupmessage/create.vue'),
    meta: { title: '任务创建' }
  },
  {
    path: '/groupmessage/detail',
    component: () => import('../pages/operation/groupmessage/detail.vue'),
    meta: { title: '任务详情' }
  },
  {
    path: '/promotionLink/list',
    component: () => import('../pages/operation/promotionLink/index.vue'),
    meta: { title: '推广链接' }
  },
  {
    path: '/miniprogram/list',
    component: () => import('../pages/operation/miniprogram/index.vue'),
    meta: { title: '小程序管理' }
  },
  {
    path: '/packagepurchase/list',
    component: () => import('../pages/operation/packagepurchase/index.vue'),
    meta: { title: '组合购管理' }
  },
  {
    path: '/packagepurchase/create',
    component: () => import('../pages/operation/packagepurchase/create.vue'),
    meta: { title: '组合购创建' }
  },
  {
    path: '/packagepurchase/edit/:id',
    component: () => import('../pages/operation/packagepurchase/edit.vue'),
    meta: { title: '组合购编辑' }
  },

]


